var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrescribers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 20C32 16.7 29.3 14 26 14C22.7 14 20 16.7 20 20C20 22.24 21.24 24.16 23.06 25.2C22 26.88 20.14 28 18 28C14.7 28 12 25.3 12 22V19.76C16.56 18.8 20 14.58 20 9.66V4C20 1.8 18.2 0 16 0H14C12.9 0 12 0.9 12 2C12 3.1 12.9 4 14 4H16V9.66C16 12.92 13.62 15.68 10.6 15.98C8.88 16.14 7.24 15.6 5.96 14.44C4.72 13.3 4 11.68 4 10V4H6C7.1 4 8 3.1 8 2C8 0.9 7.1 0 6 0H4C1.8 0 0 1.8 0 4V10C0 12.82 1.2 15.5 3.28 17.4C4.62 18.62 6.26 19.42 8 19.78V22C8 27.52 12.48 32 18 32C22.14 32 25.7 29.46 27.22 25.88C29.94 25.32 32 22.9 32 20ZM26 22C24.9 22 24 21.1 24 20C24 18.9 24.9 18 26 18C27.1 18 28 18.9 28 20C28 21.1 27.1 22 26 22Z",
    fill: "#212D41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescribers);
export default __webpack_public_path__ + "static/media/prescribers.754455feef849f6ea9c9d2b98e612749.svg";
export { ForwardRef as ReactComponent };